<template>
  <div>
    <v-row class="rounded no-gutters back-filtro pa-1" justify="center" align="center">
      <v-col cols="12" class="ma-0 pa-0 d-flex align-center">
        <span class="subtitle-1 font-weight-bold" color="primary">{{title}}</span>
        <v-tooltip top>
          <template v-slot:activator="{ on }">            
            <v-btn text icon color="primary" class="ml-auto" x-small @click="remove" v-on="on">
              <v-icon dark small>fa-trash-alt</v-icon>
            </v-btn>
          </template>
          <span>Eliminar filtro</span>
        </v-tooltip>
      </v-col> 
      <v-col cols="12" class="ColumnaResumida">
        <span class="text-primary">Seleccione Opción</span>
        <v-select
          :items="itemsSelect"
          item-text="titulo"
          item-value="valor"
          v-model="selectOpcion"
          hide-details
          outlined
          dense
        ></v-select>
      </v-col>
      <v-col cols="12" class="py-0 ma-0" dense>
        <span class="text-primary">Seleccione una Opción</span>
        <v-autocomplete
          v-model="valorConsulta"
          :items="itemsData"
          item-text="texto"
          item-value="id"
          :loading="loadSelect"
          hide-details
          clearable
          outlined
          dense>
        </v-autocomplete>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import axiosServices from "@/services/axiosServices.js"
  import mixinGridComponenteFiltros from "@/mixins/GridComponenteFiltros.js"

  export default {
    name:"Select_user",
    mixins: [mixinGridComponenteFiltros],
    data() {
      return {
        itemsSelect: [
          {titulo:'Igual',valor: '='},

        ],
        selectOpcion    : '=',
        valorConsulta   : '',
        valorConsulta2  : '',
        itemsData       : [],
        loadSelect      : false,
      }
    },
    mounted () {
      this.getItems()
    },
    methods: {
      getItems(){
        this.loadSelect = true
        let sParams = ``
        if(this.bSubdominioTemporal){
          sParams = sParams + `&subdominiot=${this.$store.state.sSubdominioTemporal}`
        }
        axiosServices.getConfiguration('/dinamicgrid_select', true ,sParams).then(aItems =>{
        //  console.log(aItems.aData)
         this.itemsData = aItems.aData
         this.loadSelect = false
        })
      },
      stringConsulta (){
        let sConsulta = ''
        switch (this.selectOpcion) {
          case '':
            sConsulta = ''
          break
          case '>=':
            sConsulta = ">= '" + this.valorConsulta + "'"
          break
          case '<=':
            sConsulta = "<= '" + this.valorConsulta + "'"
          break
          case '=':
            sConsulta = "= '" + this.valorConsulta + "'"
          break
          case 'between':
            sConsulta = " between '" + this.valorConsulta + "' AND '" + this.valorConsulta2 +"'"
          break
        }
        this.$emit("input",sConsulta)
        
        this.onAddInfoFiltro(this.campo , this.title, this.cmpValorTextoSelect)
      }
    },
    watch: {
      valorConsulta() {
        this.stringConsulta();
      },
      valorConsulta2() {
        this.stringConsulta();
      },
      selectOpcion() {
        this.stringConsulta();
      },
      indice () {
        this.getItems()
      }
    },
  }
</script>

<style scoped>
</style>